import { render, staticRenderFns } from "./ceGroupUser.vue?vue&type=template&id=bd388748"
import script from "./ceGroupUser.vue?vue&type=script&lang=js"
export * from "./ceGroupUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports